module.exports = __webpack_public_path__ + "static/img/pc.cdc1b01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/来华/pc.svg
// module id = oy0g
// module chunks = 16